import { render } from "./recurringContractUpdate.vue?vue&type=template&id=6838b356&scoped=true"
import script from "./recurringContractUpdate.vue?vue&type=script&lang=js"
export * from "./recurringContractUpdate.vue?vue&type=script&lang=js"

import "./recurringContractUpdate.vue?vue&type=style&index=0&id=6838b356&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6838b356"]])

export default __exports__